import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalNotificacionComponent } from './modal-notificacion.component';

@NgModule({
  declarations: [ModalNotificacionComponent],
  imports: [CommonModule],
})
export class ModalNotificacionModule {}
